import Header from '../modules/components/header';
import Anchors from '../modules/components/anchors';
import Menu from '../modules/components/menu';
import setupLenis from '../modules/animation/lenis';
import { addBrowserClass } from '../modules/utils/browser-detect';
import videoLoader from '../modules/utils/video-loader';

function entry () {
  addBrowserClass();
  videoLoader();
  setupLenis();
  new Header('.site-header', 150, 'sticky');

  new Menu( { menu: '.mobile-menu', toggle: '.site-menu-toggle', close: null });
  
  new Anchors();
}

window.addEventListener('DOMContentLoaded', entry);
